'use client'

/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-floating-promises */
import CarDetailsWidget from '@acko-tech/building-blocks.ui.car-details-widget'
import axios from 'axios'
import { useState } from 'react'

import logger from '@utils/logger'
import IllogicalFlowMessage from './IllogicalFlowMessage'

const NEW_CAR_REDIRECTION_URL =
  '/lp/new-comprehensive/new-car/details/?utm_source=organic&utm_medium=seo&utm_campaign=product-widget'

const CarWidget = ({ widgetOptions, isLoggedIn, isMobileDevice = false, okind }) => {
  const [isFetching, setIsFetching] = useState(false)
  const [showIllogicalFlowModal, setShowIllogicalFlowModal] = useState(false)

  const onBlurCarInput = () => null

  const onBlurMobileInput = () => null

  const getProposal = (regNo, mobNo) => {
    setIsFetching(true)
    const apiUrl = '/api/seo/consumerService/proposal'

    const goToProposal = pid => (window.location.href = `/n/car/nsr?proposal_id=${pid}`)

    axios
      .post<{ proposal_id: string }>(
        apiUrl,
        { registration_number: regNo, mobile_no: mobNo },
        { headers: { 'X-Landing-Path': '/' } }
      )
      .then(res => {
        res.data.proposal_id && goToProposal(res.data.proposal_id)
        setIsFetching(false)
      })
      .catch(error => {
        const { response } = error
        if (response.status === 403) {
          if (isLoggedIn) {
            window.location.href = process.env.NEXT_PUBLIC_MYACCOUNT_PATH || ''
          } else {
            // setIllogicalFlowData(response.data);
            setShowIllogicalFlowModal(true)
          }
        } else {
          logger.info(`[CAR WIDGET] error : ${error.message}`)
        }
        setIsFetching(false)
      })
  }

  const handleSubmit = (isValid, carNumber, mobileNumber) => {
    if (isValid) {
      setTimeout(() => {
        setIsFetching(true)
      }, 10)

      getProposal(carNumber, mobileNumber)
    }
  }

  return (
    <>
      <CarDetailsWidget
        {...widgetOptions}
        isDesktop={!isMobileDevice}
        onSubmit={handleSubmit}
        isFetching={isFetching}
        regNumberInput={{ onBlur: onBlurCarInput, onChange: () => null }}
        mobileNumberInput={{
          onBlur: onBlurMobileInput,
          onChange: () => null,
        }}
        newCarRedirectionLink={NEW_CAR_REDIRECTION_URL}
        requestUrl=""
        okind={okind}
      />

      <IllogicalFlowMessage show={showIllogicalFlowModal} />
    </>
  )
}

export default CarWidget
